const state = {
  user: null,
};

const mutations = {
  setUser(currentState, user) {
    currentState.user = user;
  },
  clearUser(currentState) {
    currentState.user = null;
  },
};

const getters = {
  isAuthenticated: (currentState) => Boolean(currentState.user),
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
